@if (data$ | async; as data) {
  <div class="mb-6 rounded-sm border border-blue-300 bg-blue-100 p-4">
    Zmiana adresu dostawy będzie miała zastosowanie od przyszłej edycji i może
    mieć wpływ na kwotę subskrypcji.
  </div>

  <app-alerts />

  <app-public-subscription-shipping-address-form
    [data]="data"
    [subscriptionNumber]="number()"
    [pending]="pending()"
    (cancelClickEvent)="handleCancelClickEvent()"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
